import { useEffect } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { FaHome } from 'react-icons/fa'
import { trackPurchase } from '../utils/pixel.jsx';

function ThankYou() {
    const navigate = useNavigate();
    const location = useLocation();
    const { success, totalPrice } = location.state || {};

    useEffect(() => {
      

        if (!success)
            navigate('/')
    }, [])

    useEffect(() => {
        trackPurchase(totalPrice);
    }, [totalPrice])



    return (
        success && (<div className='hero'>
            <div className='text-center hero-content'>
                <div className='max-w-2xl'>
                    <h1 className='text-4xl font-bold mb-8'>Ви благодариме на нарачката 🎉</h1>
                    <p className='text-2xl mb-8'>Вашата нарачка е успешно обработена. Ви благодариме што го избравте <span className='font-bold'>Мал Сервис</span>!</p>

                    <div className='p-[40px]'>
                        <ul className="list-disc text-left">
                            <li className='pb-[20px]'>Вашата нарачка ќе биде подготвена и испратена што е можно поскоро.</li>
                            <li className='pb-[20px]'>Ќе добиете е-маил со потврда за нарачката.</li>
                            <li className='pb-[20px]'>Ако имате било какви прашања или забелешки, слободно контактирајте не.</li>
                        </ul>
                    </div>
                    <Link to='/' className='btn btn-primary btn-lg'>
                        <FaHome className='mr-2' />
                        Почетна
                    </Link>
                </div>
            </div>
        </div>)
    )
}

export default ThankYou
